import { StyledButton } from '../../common/styledComponents'
import { Icon } from 'semantic-ui-react'

const GoogleFormBtn = () => {

    const googleFormUrl: string = window._env_.GOOGLE_FORM_URL

    const openGoogleForm = () => window.open(googleFormUrl, '_blank')
    
    return (
        <StyledButton onClick={openGoogleForm}>
            <Icon name="mail" />
            Feedback
        </StyledButton>
    )
}

export default GoogleFormBtn